import { native } from '@forest/native-services'
import { Dialog } from '@forest/shared/solid'
import { ErrorBoundary, lazy, onMount, Show } from 'solid-js'
import { openLoadFailureDialog } from '~/lib/load-failure-dialog'
import { shouldShowDevPanel } from '~/lib/params'
import { Page } from '~/page'

const DevPanel = import.meta.env.DEV
  ? lazy(() =>
      import('~/components/dev-panel').then((m) => ({ default: m.DevPanel })),
    )
  : () => null

export function App() {
  onMount(() => {
    native.general.pageReady()
    native.general.logEvent({
      event_name: 'page_view',
      event_params: { page_name: 'focus_challenge' },
    })
  })

  return (
    <>
      <ErrorBoundary fallback={(error) => <LoadFailure error={error} />}>
        <Page />
        <Show when={import.meta.env.DEV && shouldShowDevPanel}>
          <DevPanel />
        </Show>
      </ErrorBoundary>
      {/* Outside the boundary, so a failed render can still show its dialog. */}
      <Dialog />
    </>
  )
}

/**
 * A read the page renders from failed (e.g. the reward tree's name): the page
 * cannot show, so it ends like any other page-load failure.
 */
function LoadFailure(props: { error: unknown }) {
  onMount(() => {
    console.error(props.error)
    openLoadFailureDialog(props.error, { closesPage: true })
  })
  return null
}
